export interface PicItem {
  fileOssPath?: string;
  fileName?: string;
  ossUrl?: string;
  url?: string;
  encryptFlag?: number;
  type?: number;
}

/**
 * 解析单张图片地址
 * - encryptFlag=1：ossUrl 是加密文件下载地址，fetch 转 blob 后回显
 * - 其他：直接返回 ossUrl / url
 */
export async function resolveImageUrl(pic: PicItem): Promise<string> {
  const rawUrl = pic.ossUrl || pic.url || '';

  if (pic.encryptFlag !== 1 || !rawUrl) {
    return rawUrl;
  }

  try {
    const response = await fetch(rawUrl);
    if (!response.ok) throw new Error(`下载失败: ${response.status}`);
    const blob = await response.blob();
    return URL.createObjectURL(blob);
  } catch (e) {
    console.error('加密图片下载失败', e);
    return rawUrl;
  }
}

/**
 * 批量解析图片地址列表
 */
export async function resolveImageUrls(pictures: PicItem[]): Promise<string[]> {
  if (!pictures || pictures.length === 0) return [];
  return Promise.all(pictures.map(pic => resolveImageUrl(pic)));
}
